import { gql } from "@apollo/client";

export const makesQuery = gql`
  query ($manufacturer: String) {
    rv_makes(manufacturer: $manufacturer)
  }
`;
